import { BaseModel } from './base-model.interface';
import BlockModel from './block-model.interface';
import { NotificationInitVariables } from '../template/notifications-model.interface';

export interface EventModel extends BaseModel {
  variables?: { [key: string]: string } | EventVariables;
}

export interface EventVariables {
  EventImageDesktop: string;
  EventImageMobile: string;
  EventImageHref: string;
  EventImageAlt: string;
  EventText: string;
  EventCtaLink: string;
  EventCtaText: string;
  EventImageHrefSegmentRegex: string;
  EventCtaLinkSegmentRegex: string;
}

export class EventInitVariables implements EventVariables {
  EventImageDesktop = '';
  EventImageMobile = '';
  EventImageHref = '';
  EventImageAlt = '';
  EventText = '';
  EventCtaLink = '';
  EventCtaText = '';
  EventImageHrefSegmentRegex = '';
  EventCtaLinkSegmentRegex = '';
}

export class EventInitModel implements BlockModel {
  blockId: string = '';
  count: number = 0;
  name: string = '';
  variables: { [key: string]: string };
  notifications: NotificationInitVariables[];

  constructor() {
    const initVars = new EventInitVariables();
    this.variables = { ...initVars };
    this.notifications = [new NotificationInitVariables()];
  }
}
